//设备看板-统计数据弹窗
import React, {
  Component,
} from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import ScGridTable from "../../../components/display/table/gridTableCore";
import FormCore from "../../../components/display/form/formCore";
import monthPickerHoc from "../../../hoc/form/monthPickerHoc";
import RefreshGrid from "../../../utils/refreshGrid";
import { queryTicketAreaNumListCityQry } from "../../../fetch/fetchApi";
// 国际化切换语言
@monthPickerHoc
// eslint-disable-next-line arrow-parens
@connect(state => state)
class orderTotalModal extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubStatusLog;
    this.state = {
      modalTitle:"",
      chooseIndex:0,
      gridData: [
      //   {id:2,text:"东区", choosed:2}, 
      // {id:3,text:"东区", choosed:1}, 
      // {id:4,text:"东区", choosed:1}, 
      // {id:5,text:"东区", choosed:1}, 
      // {id:6,text:"东区", choosed:1}
    ],
      exportMes: this.internationalization.btn2, // '导出',
    };
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.query = {
      month: this.props.modalParam.month,
      pieData: this.props.stubIdData,
      firstId:this.props.firstId,
      modalType:this.props.modalType,
      modalStationTitle:this.props.modalStationTitle,
      modalStationNum:this.props.modalStationNum,
      page: 1,
      operationMode:this.props.modalParam.operationMode,
      stubType:this.props.modalParam.stubType,
      cityIds: this.props.modalParam.cityIds,
      appKey:this.props.modalParam.projectNames,
      provinceIds: this.props.modalParam.provinceIds,
      startTime: this.props.modalParam.startTime,
      endTime: this.props.modalParam.endTime,
    };
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    }
    
    componentWillMount() {
      if (this.query && this.query.pieData)
      {
        this.setState({
          modalTitle:this.query.modalStationTitle
        });
      }
      //查询大区列表和电站总数
      this.init();
    }

    init() {
      this.formConfig = {
        childItems: [
          //     {
          //     width: '100%',
          //     param: {
          //         name: 'month',
          //         type: 'object'
          //     },
          //     defaultValue: moment(new Date(), 'YYYY-MM'),
          //     required: !1,
          //     labelName: this.internationalization.title1,//'月份选择',
          //     format: this.props.format,
          //     plugin: this.props.monthPicker[0](this.internationalization.title1, 'month')
          //  },
          // {
          //   type: "date",
          //   dateType: "rangeDate",
          //   placeholder: ["开始时间", "结束时间"],
          //   param: {
          //     name: "date",
          //     type: "array",
          //   },
          //   width: "240px",
          //   allowClear: false,
          //   defaultValue: [momentFirst, moment(new Date())],
          //   validator: { // 日期自定义校验规则
          //     vtype: "date", // 校验名称  
          //     range: 0,
          //     max_val:365,
          //     notOverYear: true,
          //   }, // 自定义校验规则
          //   labelName: "起止日期", // '订单结束时间:',
          //   required: !0,
          // }, 
          // {
          //   type: "buttonGp", // 表单最终执行组
          //   buttonArr: [{
          //     btnType: "submit",
          //     text: this.internationalization.btn1, // '查询',
          //     // icon: 'search'
          //   }
          //   , {
          //     btnType: "button",
          //     text: this.internationalization.btn2, // '导出',
          //     icon: "export",
          //     handler: (e, param) => {
          //       this.exportData(param);
          //     },
          //   }
          // ],
          // }
        ], // 设置表单元素
        layout: this.layout[0], // 设置布局 0： 横向布局， 1：弹窗布局 2： 全页表单布局
        formTarget: "grid", // 表单提交类型，设置grid则为更新grid
        defaultParams: {
          regId: this.query.firstId,
          cityIds: this.query.cityIds,
          type:this.query.modalType,
          month: this.query.month,
          stubType: this.query.stubType,
          operationMode: this.query.operationMode,
        },
        autoLoadGrid: !0, // 设置为false不触发加载grid
        context: this,
        tableKey: "moduleStationLog",
      };
      this.setState({
        tableConfig: {
          tableColumns: [
          //   {
          //   name: '排名', 
          //   key: "rankNum",
          //   align: "center",
          // }, 
          {
            name: '城市', 
            key: "cityName",
          }, {
            name: '数值', 
            key: "lookTime",
            colType: "tipCol",
            tipNum: 15,
          }],
          tableChange: () => {

          },
          tableParam: {
            pageCount: 10,
          },
          tableInfo: {
            hasRow: !1, // 是否显示checkbox
          },
          autoRefresh: !1, // 设置为true 直接加载grid数据
          dataApi: queryTicketAreaNumListCityQry,
          tableKey: "moduleStationLog",
        },
      });
    }

    fetchApi = (params) => {
      let result = {
        ...params,
      };
      
      return result;
    };


    handleOrderDetailModalCancel = () => {
      this.setState({
        orderDetailVisible: false,
      });
    }

    render() {
      return (
        <div className="sc-page-content">
          <div style={{fontSize:"14px", fontWeight:"500"}}>总数值：{this.query.modalStationNum}</div>
          <div style={{width:"100%", overflow:"hidden", whiteSpace:"nowrap", margin:"10px 0", overflowX:"auto", paddingBottom:"5px"}}>

            {this.query.pieData.map((d, index) => (
            // <Option key={d.value}>{d.text}</Option>

            <div onClick={(e) => {
              this.setState({
                chooseIndex:index,
                modalTitle:d.text
              })
              RefreshGrid(this.context.store, "moduleStationLog", {regId:d.id})
            }} className={index===this.state.chooseIndex?"activeCho":null} style={{cursor:"pointer", display:"inline-block",border:"1px solid #eeeeee", width:"150px", height:"80px", padding:"10px 10px", marginRight:"10px"}}>
            <div style={{fontSize:"14px"}}>{d.text}</div>
            <div style={{fontSize:"18px", fontWeight:"550"}}>{d.num}</div>
        </div>
          ))}
            
          </div>
          <div style={{display:"flex", alignItems:"center"}}>
            <span style={{display:"inline-block;", backgroundColor:"#1e80ff", width:"4px", height:"12px", marginRight:"5px"}}></span>
            <span style={{fontSize:"14px"}}>{this.state.modalTitle}城市分布情况</span>
          </div>
          <FormCore
            formConfig={this.formConfig}
            getInstance={this.props.getInstance}
            fetchApi={this.fetchApi} />
          <div className="page-panel no-table-footer" style={{ marginTop: 15 }}>
            <ScGridTable config={this.state.tableConfig} unTotalMode />
          </div>
        </div>
      );
    }
}

export default injectIntl(orderTotalModal);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/ticketTotalModal.js